import React from 'react'
import { Circle, TileLayer,withLeaflet,  Popup, Marker,  Tooltip, ZoomControl, Polygon, Polyline, Map  } from "react-leaflet";
import MeasureControlDefault from 'react-leaflet-measure'; //https://www.npmjs.com/package/react-leaflet-measure
import L from 'leaflet';
import "leaflet/dist/leaflet.css";//https://towardsdatascience.com/creating-a-bubbles-map-using-react-leaflet-e75124ca1cd2
import { point } from 'leaflet';

import Conexao from '../../../providers/Conexao'
import { Icon, DivIcon } from "leaflet";
//import {Marker,} from 'react-leaflet-enhanced-marker' //https://www.npmjs.com/package/react-leaflet-enhanced-marker
import MarkerClusterGroup from "react-leaflet-markercluster";
import IconeTecnico from './icones/iconeAtendenteTecnico.png'
import IconeRevenda from './icones/iconeRevenda.png'
import IconeCliente from './icones/iconeCliente.png'
import IconeCarroON from './icones/iconeCarroOn.png'
import IconeCarroOFF from './icones/iconeCarroOFF.png'
import IconConsumo from '@material-ui/icons/LocalGasStation'
import IconRPM from '@material-ui/icons/ThreeSixtySharp'
import IconIgnition from '@material-ui/icons/VpnKey'
import CalendarIcon from '@material-ui/icons/CalendarToday'
import VeiculoIcon from '@material-ui/icons/DirectionsCar'
import IconeVoltage from '@material-ui/icons/BatteryFullRounded'
import Swal from 'sweetalert2';
import {Button} from '@material-ui/core'
import AlertIcon from '@material-ui/icons/Warning'
/*

https://www.luiztools.com.br/post/arquitetura-assincrona-pubsub-com-redis-nodejs/



                                        */


    const iconTecnico = new Icon({
      iconUrl: IconeTecnico,
      iconSize: [32, 54], 
      iconAnchor :[
          20, 30
      ], 
      popupAnchor: [0, 0]
    });

    const iconeVeiculo = new Icon({
      iconUrl: IconeCarroON,
      iconSize: [24, 46], 
      iconAnchor :[
          20, 30
      ], 
      popupAnchor: [0, 0]
    });
    const iconeVeiculoOFF = new Icon({
      iconUrl: IconeCarroOFF,
      iconSize: [24, 46], 
      iconAnchor :[
          20, 30
      ], 
      popupAnchor: [0, 0]
    });

    const iconeRevenda = new Icon({
      iconUrl: IconeRevenda,
      iconSize: [54, 54], 
      iconAnchor :[
          0, 0
      ], 
      popupAnchor: [0, 0]
    });

    const iconeCliente = new Icon({
      iconUrl: IconeCliente,
      iconSize: [54, 54], 
      iconAnchor :[
          25, 0
      ], 
      popupAnchor: [0, 0]
    });


export default function (props){

    const [regioes, setRegioes] = React.useState([]);
    const [veiculosMarker, setViculosMarker] = React.useState([]);
    const [centroMapa, setCentroMapa] = React.useState([(props.latitude && props.latitude != null) ? props.latitude : -22.2244322, (props.longitude && props.longitude != null) ? props.longitude : -49.8917842]);
    //const [breakPoints, setBreakPoints] = React.useState([])
    const [contador, setContador]= React.useState(0)
    const breakPoints = [];
    const [veiculo, setVeiculo] = React.useState({
      idusuario : -1, 
      marca : '', 
      modelo : '', 
      placa : '', 
      idrastreador : ''
  })

  const [sliderHoras, setSliderHoras]= React.useState([props.filtroTempo[0],props.filtroTempo[1]]);

    React.useEffect(()=>{
     
       // getRegioes()
        getVeiculosByEmpresa();
        const timer = setInterval(()=>{
          getVeiculosByEmpresa();
        }, 10000)



        return ()=> clearInterval(timer)
    },[]);

    React.useEffect(()=>{
      
      setSliderHoras([props.filtroTempo[0],props.filtroTempo[1]])

   },[props.filtroTempo]);

    const handlePositionLine = (posicao)=>{
     
    
    }

    React.useEffect(()=>{
     setVeiculo(props.veiculo)
   },[props.veiculo]);

   React.useEffect(()=>{

    setSliderHoras(props.filtroTempo)
   
  },[props.filtroTempo]);
    


    const getRegioes = () =>{
      Conexao.get('empresasController/getRegioes?idUsuario='+props.idusuario+'&idEmpresa='+props.idempresa).then(response=>{
        if(response.data.status =='OK'){
          setRegioes(response.data.payload)
        }else{
          setRegioes([])
        }
      }).catch(error=>{
        setRegioes([])
      })
    }

    function getVeiculosByEmpresa(){
      console.log(props.filtroTempo)
      Conexao.get('fleetController/getVeiculosByEmpresa?idUsuario='+props.revenda+'&idEmpresa='+props.idempresa).then(response=>{
        if(response.data.status =='OK'){
          setViculosMarker(response.data.payload)
          if(response.data.payload[0]){   
            setContador(contador + 1)  
            if(contador == 10){
              setCentroMapa([response.data.payload[0].latitude, response.data.payload[0].longitude])
              setContador(0)
            }       
            if(response.data.payload[0].statusignicao == 't'){
              //breakPoints = [{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.756205,"lng":-50.551731},{"lat":-22.743218,"lng":-50.53962},{"lat":-22.730961,"lng":-50.53789},{"lat":-22.724681,"lng":-50.541686},{"lat":-22.789481,"lng":-50.548594},{"lat":-22.789528,"lng":-50.548911},{"lat":-22.720179,"lng":-50.544832},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.716198,"lng":-50.539731},{"lat":-22.692004,"lng":-50.507029},{"lat":-22.686733,"lng":-50.499938},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.681354,"lng":-50.492622},{"lat":-22.675917,"lng":-50.48524},{"lat":-22.653231,"lng":-50.454511},{"lat":-22.636995,"lng":-50.432602},{"lat":-22.636995,"lng":-50.432602},{"lat":-22.636995,"lng":-50.432602},{"lat":-22.637084,"lng":-50.428552},{"lat":-22.637084,"lng":-50.428552},{"lat":-22.637084,"lng":-50.428552},{"lat":-22.637545,"lng":-50.421708},{"lat":-22.637545,"lng":-50.421708},{"lat":-22.637545,"lng":-50.421708},{"lat":-22.640713,"lng":-50.419207},{"lat":-22.64403,"lng":-50.418705},{"lat":-22.64403,"lng":-50.418705},{"lat":-22.64403,"lng":-50.418705},{"lat":-22.646027,"lng":-50.418326},{"lat":-22.646027,"lng":-50.418326},{"lat":-22.646027,"lng":-50.418326},{"lat":-22.649038,"lng":-50.41785},{"lat":-22.649038,"lng":-50.41785},{"lat":-22.649038,"lng":-50.41785},{"lat":-22.652051,"lng":-50.417407},{"lat":-22.652051,"lng":-50.417407},{"lat":-22.652051,"lng":-50.417407},{"lat":-22.654423,"lng":-50.416819},{"lat":-22.654423,"lng":-50.416819},{"lat":-22.654423,"lng":-50.416819},{"lat":-22.65672,"lng":-50.416667},{"lat":-22.65672,"lng":-50.416667},{"lat":-22.65672,"lng":-50.416667},{"lat":-22.658059,"lng":-50.416685},{"lat":-22.658059,"lng":-50.416685},{"lat":-22.658059,"lng":-50.416685},{"lat":-22.660457,"lng":-50.416632},{"lat":-22.660457,"lng":-50.416632},{"lat":-22.660457,"lng":-50.416632},{"lat":-22.661519,"lng":-50.41661},{"lat":-22.661519,"lng":-50.41661},{"lat":-22.661519,"lng":-50.41661},{"lat":-22.661492,"lng":-50.416602},{"lat":-22.661492,"lng":-50.416602},{"lat":-22.661492,"lng":-50.416602},{"lat":-22.662406,"lng":-50.415797},{"lat":-22.662406,"lng":-50.415797},{"lat":-22.662406,"lng":-50.415797},{"lat":-22.662423,"lng":-50.414419},{"lat":-22.662423,"lng":-50.414419},{"lat":-22.662423,"lng":-50.414419},{"lat":-22.662411,"lng":-50.412668},{"lat":-22.662411,"lng":-50.412668},{"lat":-22.662411,"lng":-50.412668},{"lat":-22.662405,"lng":-50.410317},{"lat":-22.662329,"lng":-50.409449},{"lat":-22.662329,"lng":-50.409449},{"lat":-22.662241,"lng":-50.409468},{"lat":-22.662129,"lng":-50.409451},{"lat":-22.662129,"lng":-50.409451},{"lat":-22.662129,"lng":-50.409451},{"lat":-22.661622,"lng":-50.411076},{"lat":-22.661622,"lng":-50.411076},{"lat":-22.661622,"lng":-50.411076},{"lat":-22.661619,"lng":-50.411693},{"lat":-22.661619,"lng":-50.411693},{"lat":-22.661619,"lng":-50.411693},{"lat":-22.661624,"lng":-50.412187},{"lat":-22.661624,"lng":-50.412187},{"lat":-22.661624,"lng":-50.412187},{"lat":-22.661682,"lng":-50.415098},{"lat":-22.661682,"lng":-50.415098},{"lat":-22.661682,"lng":-50.415098},{"lat":-22.661642,"lng":-50.416149},{"lat":-22.661642,"lng":-50.416149},{"lat":-22.661642,"lng":-50.416149},{"lat":-22.662858,"lng":-50.416522},{"lat":-22.662858,"lng":-50.416522},{"lat":-22.662858,"lng":-50.416522},{"lat":-22.663268,"lng":-50.417082},{"lat":-22.663268,"lng":-50.417082}]            
            }  
            console.log(JSON.stringify(breakPoints))           
          }
          
        }else{
          setViculosMarker([])
        }
      }).catch(error=>{
        setViculosMarker([])
      })
    }



    return <div style ={{height: "100%", marginTop:"0px", width: "100%", }}>
        <Map
          id="modalMap"                        
          animate={true}
          style={{ height: "100%", width: "100%", }}
          minZoom={10}
          zoom={props.defaultZoon ? props.defaultZoon : 12 }                        
          zoomControl={true}           
          maxZoom={18}                                             
          center={centroMapa}    
          onclick={(e)=>{
           handlePositionLine(e.latlng)
           //console.log(e)
          }}    
          >
            <TileLayer url="http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />


            {
              regioes && regioes.map(function(regiao, i){
                return <Circle
                fillColor={regiao.cor}
                stroke ={false}                
                center = {[regiao.latitude, regiao.longitude]}
                radius = {regiao.raio}
              />
              })
            }

            {
              veiculosMarker && veiculosMarker.map(function(veiculo, i){
                return <Marker 
                key={'TEC'+i}                              
                position={[veiculo.latitude ? veiculo.latitude : 0, veiculo.longitude ? veiculo.longitude : 0]}                                                        
                icon={L.divIcon({
                  className: 'custom icon', 
                  iconAnchor :[0, 15], 
                  html: '<div class="div-marker-car"><img height="40" width:"40" style="transform: rotate('+veiculo.azimuth+'deg)" src="'+(veiculo.ignicao == '1'  ? "http://www.printerconnect.com.br/api/imagens/carroLigado.png" : "http://www.printerconnect.com.br/api/imagens/carroDesligado.png")+'"/><span class="centericone-rotulo'+(veiculo.ignicao == '1' ?'t':'f')+'">'+(props.display =='velocidade' ? veiculo.velocidade+' Km/h': veiculo.placa)+'</span></div>'
                  })}>
                  <Popup>
                          <div style ={{display:"flex", width:"300px"}} className='div-pop-map'>
                               <div className='div-icon-car-popup'>
                               
                                 <div className='div-pop-map-icon-container' style = {{backgroundColor: veiculo.ignicao == '1'  ? 'green' : 'red' }}>
                                    <VeiculoIcon />
                                 </div>
                                  <div style ={{textAlign:'center', width:'100%'}}> <span style ={{fontSize:'10px'}}>{veiculo.velocidade} Km/h</span></div>
                               
                               </div>
                               
                               <div style ={{width:"80%", paddingLeft:"10px"}}>
                                 
                                    <table style ={{fontSize:'12px'}}  className='table-fleet' >
                                      <tr>
                                        
                                        <td  colSpan='2'><strong style ={{fontSize:'14px', fontWeight:'bold'}}>{veiculo.placa+' '+veiculo.modelo}</strong></td>
                                      </tr>
                                      <tr>
                                        <td style = {{width:'5%'}}><CalendarIcon /></td>
                                        <td style = {{width:'95%', fontSize:'11px'}}>{veiculo.dataposicao ? veiculo.dataposicao+' '+veiculo.horaposicao : 'n/d'}</td>
                                      </tr>
                                      <tr>
                                        <td style = {{width:'5%'}}><IconConsumo /></td>
                                        <td style = {{width:'95%', fontSize:'11px'}}>{veiculo.consumo ? veiculo.consumo : 0} Km/l</td>
                                      </tr>
                                      <tr>
                                        <td style = {{width:'5%'}}><IconRPM /></td>
                                        <td style = {{width:'95%', fontSize:'11px'}}>{veiculo.rpm ? veiculo.rpm : 0} rpm</td>
                                      </tr>
                                      <tr>
                                        <td style = {{width:'5%'}}><IconIgnition /></td>
                                        <td style = {{width:'95%', fontSize:'11px'}}>{veiculo.ignicao == '1'  ? 'Ligada' : 'Desligada'}</td>
                                      </tr>
                                      <tr>
                                        <td style = {{width:'5%'}}><IconeVoltage /></td>
                                        <td style = {{width:'95%', fontSize:'11px'}}>{veiculo.charging =='t' ? 'Carregando...' : veiculo.voltagemexterna}</td>
                                      </tr>                                         
                                    </table>
                                    <Button variant='outlined' className='btn-info' fullWidth style ={{marginTop:'5px'}} onClick={()=>{
                                      Swal.fire({
                                        title : 'Printerconnect - Frota', 
                                        text : 'Deseja consultar o trajeto deste veículo agora?', 
                                        icon : 'question', 
                                        showConfirmButton : true, 
                                        confirmButtonText : 'Sim', 
                                        showCancelButton : true, 
                                        cancelButtonText : 'Não'
                                      }).then(resp=>{
                                        if(resp.isConfirmed){
                                          if(props.setVeiculo){
                                            props.setVeiculo({
                                              idusuario : veiculo.idusuario, 
                                              marca : veiculo.marca, 
                                              modelo : veiculo.modelo, 
                                              placa : veiculo.placa, 
                                              idrastreador : veiculo.idrastreador
                                            })
                                          }
                                          
                                        }
                                      })
                                    }}>Ver Trajeto</Button>
                               </div> 
                               
                        </div>
                 </Popup>
                  
                </Marker>


             



              })
            }


 
                {breakPoints && <Polyline positions = {breakPoints}
                    color='#573983'
                    lineCap='square'
          /> }
                 
          </Map>
          {
            <span>{props.veiculo.idrastreador}</span>
          }
        </div>
  
}